import {Grid} from "@mui/material";
import ImportFile from "../../../../components/import-file/import-file.component";

const ImportForecast = () => (
    <Grid item xs={12} sx={{paddingBottom: "16px"}}>
        <ImportFile type={"forecast"} />
    </Grid>
);

export default ImportForecast;
